import React from 'react';
import {skipToken} from '@reduxjs/toolkit/query/react';
import {useGetJailsQuery} from '../store/api/jailApi';
import {messageType, showMessages} from '../helpers/message';
import {
    HasJailParams,
    HasJailReturn,
    JailItem,
    UseGetJailsParams
} from '../types/accountTypes';
import {BaseError} from '../types/apiTypes';

const useGetJails = ({isStaff, profile}: UseGetJailsParams) => {
    // Skip running these queries if account/profile are undefined or not staff.
    const {data: accountJails, isFetching: accountJailsLoading, isError: isAccountError, error: accountError} = useGetJailsQuery(
        isStaff && profile?.account ? {
            modelID: profile.account?.id,
            modelType: 'account',
        } : skipToken
    );
    const {data: profileJails, isFetching: profileJailsLoading, isError: isProfileError, error: profileError} = useGetJailsQuery(
        isStaff && profile ? {
            modelID: profile.id,
            modelType: 'profile',
        } : skipToken
    );

    if (isProfileError || isAccountError) {
        profileError &&
            showMessages(`Something went wrong fetching restrictions: ${(profileError as BaseError).data?.message}`, messageType.error);
        accountError &&
            showMessages(`Something went wrong fetching restrictions: ${(accountError as BaseError).data?.message}`, messageType.error);
    }

    let result: JailItem[] = [];
    if (profileJails) {
        result = result.concat(profileJails);
    }
    if (accountJails) {
        result = result.concat(accountJails);
    }

    return {
        jails: result,
        isJailsLoading: accountJailsLoading || profileJailsLoading,
    }
}

const useHasJail = ({profile, isStaff, jailName}: HasJailParams): HasJailReturn => {
    const {jails, isJailsLoading} = useGetJails({profile, isStaff});

    const hasJail = React.useMemo(() => {
        return jails.some(jail => jail.name === jailName);
    }, [jailName, jails]);

    return [hasJail, isJailsLoading];
}
export {useGetJails, useHasJail};
